import { reviews } from '@/mocks/comics';

export default function ReviewsSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto mb-8 max-w-2xl text-center">
        <span className="text-xs font-medium tracking-wide text-primary-600">REVIEWS</span>
        <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">追漫人怎么说</h2>
        <p className="mt-2 text-sm text-foreground-600">真实追番体验，铸就口碑</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {reviews.map((r) => (
          <figure
            key={r.name}
            className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-secondary-300"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-medium text-white ${r.color}`}>
                  {r.name.slice(0, 1)}
                </span>
                <div>
                  <figcaption className="text-sm font-semibold text-foreground-900">{r.name}</figcaption>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </div>
              <span className="flex items-center gap-1 text-sm text-secondary-600">
                {r.rating}<i className="ri-star-fill"></i>
              </span>
            </div>
            <blockquote className="text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
          </figure>
        ))}
      </div>
    </section>
  );
}